module.exports = __webpack_public_path__ + "img/animals_04_H.c6eb1ca9.webp";